import React from 'react'
import PropTypes from 'prop-types'
import { withHover } from './withHover'
import { View, Text, StyleSheet } from 'react-native'
import { Swatch } from './swatch'
import { SwatchImage } from './swatch-image'
import { SwatchType, GroupMin } from '../types/swatch'
import { Group } from '../types/group'

function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

const SwatchImageWithHover = withHover(SwatchImage)

type SwatchImageGroupProps = {
  sku?: string,
  /** The name of the image group */
  name: string,
  /** The primary color of the app. */
  accentColor: string,
  /** The selected color swatch. */
  selected: number,
  /** An object describing the color swatches. */
  swatches: SwatchType,
  /** On swatchchange handler. */
  onImageSwatchChange: Function,
  partner: string,
  /** Drilled to determine if on mobile */
  onMobile: boolean
}

type SwatchImageGroupState = {
  /** Boolean for determining to show hover view on color swatches */
  isHovered: boolean,
}

/**
 * A group of `SwatchImage`. A group of color options.
 * @component
 */
export class SwatchImageGroup extends React.Component<SwatchImageGroupProps, SwatchImageGroupState> {
  static propTypes = {
    sku: PropTypes.string,
    name: PropTypes.string.isRequired,
    accentColor: PropTypes.string.isRequired,
    selected: PropTypes.number.isRequired,
    swatches: PropTypes.object.isRequired,
    onImageSwatchChange: PropTypes.func.isRequired,
    partner: PropTypes.string.isRequired,
  }

  static defaultProps = {
    name: 'Upholstery',
  }

  onPatriotSwatchClick(key: number) {
    this.props.onImageSwatchChange(key, this.props.name, 0)
  }

  onSupernovaSwatchClick(key: number) {
    this.props.onImageSwatchChange(key, this.props.name, 1)
  }

  render() {
    return (
      <View>
        <Text style={styles.groupLabel}>{capitalizeFirstLetter(this.props.name)}</Text>
        <View style={styles.swatchGroup}>
          {

            (this.props?.swatches?.group?.find((node: GroupMin) => node.option.includes('85') || node.option.includes('86'))) &&
            <View style={styles.supernovaInfoButton}>
            {
              (this.props.partner === 'fisher' || this.props.partner == 'fisheredu' || this.props.partner == 'fishered') &&
              <Text style={styles.materialLabel}>Grade B</Text>
            }
            {
              (this.props.partner != 'fisher' && this.props.partner != 'fisheredu' && this.props.partner != 'fishered') &&
              <Text style={styles.materialLabel}>Trailblazer{'\u2122'}</Text>
            }

              <Text style={styles.materialDescription}>Our everyday workhorse vinyl has a finish that protects against abrasions and is non-porous to defend against spills.</Text>
            </View>
          }
          <View style={styles.swatchGroupInner}>
          {this.props?.swatches?.group?.filter((node: GroupMin) => node.option.includes('85') || node.option.includes('86'))?.map((swatch: GroupMin, key) => {
            if (!this.props.onMobile) {
              return (
                <SwatchImageWithHover
                  accentColor={this.props.accentColor}
                  key={key}
                  keyID={key}
                  label={swatch.label}
                  // eslint-disable-next-line
                  selected={key === this.props.swatches.selected}
                  onSwatchClick={this.onPatriotSwatchClick.bind(this)}
                  option={swatch.option}
                />
              )
            } else {
              return (
                <SwatchImage
                  accentColor={this.props.accentColor}
                  key={key}
                  keyID={key}
                  label={swatch.label}
                  // eslint-disable-next-line
                  selected={key === this.props.swatches.selected}
                  onSwatchClick={this.onPatriotSwatchClick.bind(this)}
                  option={swatch.option}
                />
              )
            }
          })
          }
          </View>
        </View>
        <View style={{height: 20}}></View>
        <View style={styles.swatchGroup}>
          {
            this.props?.swatches?.group?.find((node: GroupMin) => node.option.includes('88')) &&
            <View style={styles.supernovaInfoButton}>
            {
              (this.props.partner === 'fisher' || this.props.partner == 'fisheredu' || this.props.partner == 'fishered') &&
              <Text style={styles.materialLabel}>Grade A</Text>
            }
            {
              (this.props.partner != 'fisher' && this.props.partner != 'fisheredu' && this.props.partner != 'fishered') &&
              <Text style={styles.materialLabel}>Supernova{'\u2122'}</Text>
            }

              <Text style={styles.materialDescription}>Our highest-grade vinyl has a unique texture, and an antibacterial additive, yet remains non-porous and ideal for harsh settings.</Text>
            </View>
          }
          <View style={styles.swatchGroupInner}>
          {this.props?.swatches?.group?.filter((node: GroupMin) => node.option.includes('88'))
            ?.map((swatch: GroupMin, key: number) => {
              if (!this.props.onMobile) {
                return (
                  <SwatchImageWithHover
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected - (this.props.swatches.group?.filter((node: GroupMin) => node.option.includes('85') || node.option.includes('86')).length ?? 0)}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              } else {
                return (
                  <SwatchImage
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected - (this.props.swatches.group?.filter((node: GroupMin) => node.option.includes('85') || node.option.includes('86')).length ?? 0)}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              }
          })
          }
          </View>
        </View>
        <View style={styles.swatchGroup}>
          {
            this.props?.swatches?.group?.find((node: GroupMin) => node.option.includes('F')) &&
            <Text style={styles.materialDescription}>Regular everyday fabric.</Text>
          }
          {
            this.props?.swatches?.group?.find((node: GroupMin) => node.option.includes('ESDBLU') && this.props.sku?.includes('V')) &&
            <Text style={styles.materialDescription}>Upholstered with special static dissipative ESD Vinyl</Text>
          }
          {
            this.props?.swatches?.group?.find((node: GroupMin) => node.option.includes('ESDBLU') && this.props.sku?.includes('F')) &&
            <Text style={styles.materialDescription}>Upholstered with special static dissipative ESD Fabric</Text>
          }
          <View style={styles.swatchGroupInner}>
          {this.props?.swatches?.group?.filter((node: GroupMin) => node.option.includes('F'))
            ?.map((swatch: GroupMin, key: number) => {
              if (!this.props.onMobile) {
                return (
                  <SwatchImageWithHover
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              } else {
                return (
                  <SwatchImage
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              }
          })
          }
          </View>
        </View>
        <View style={styles.swatchGroup}>
          <View style={styles.swatchGroupInner}>
          {this.props?.swatches?.group?.filter((node: GroupMin) => node.option.includes('BLU') || node.option.includes('BLK') || node.option.includes('GRY'))
            ?.map((swatch: GroupMin, key: number) => {
              if (!this.props.onMobile) {
                return (
                  <SwatchImageWithHover
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              } else {
                return (
                  <SwatchImage
                    accentColor={this.props.accentColor}
                    key={key}
                    keyID={key}
                    label={swatch.label}
                    // eslint-disable-next-line
                    selected={key === this.props.swatches.selected}
                    onSwatchClick={this.onSupernovaSwatchClick.bind(this)}
                    option={swatch.option}
                  />
                )
              }
          })
          }
          </View>
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  swatchGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  swatchGroupInner: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  groupLabel: {
    fontWeight: 'bold',
    margin: 10,
  },
  materialLabel: {
    marginLeft: 10,
    fontWeight: 'bold',
  },
  materialDescription: {
    marginLeft: 10,
    fontWeight: 'normal',
    paddingTop: 2,
    paddingBottom: 2,
  },
  supernovaInfoButton: {
    display: 'flex',
    flexDirection: 'column',
  }
})
